import { MANAGE_NOTE_ADD, MANAGE_NOTE_EDIT, MANAGE_NOTE_PIN, MANAGE_NOTE_REMOVE, MANAGE_NOTE_VIEW, MANAGE_NOTES_V2 } from "config/apiPaths"
import { baseApi } from 'utils/axios/baseApi';
import { noteApi } from "../note";

export const noteApiV2 = baseApi.injectEndpoints({
    endpoints: (builder) => ({

        // create note
        createNote: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_NOTES_V2.CREATE,
                data
            }),
            invalidatesTags: ["NoteDetails"]
            // async onQueryStarted(arg, { dispatch, queryFulfilled }) {
            //     try {
            //         await queryFulfilled;

            //         // Invalidate tag from another API
            //         dispatch(
            //             noteApi.util.invalidateTags(["NoteDetails"])
            //         );
            //     } catch (err) {
            //         console.error("Failed to create note:", err);
            //     }
            // },
        }),

        // update note
        updateNote: builder.mutation({
            query: ({ data, id }) => ({
                method: "POST",
                url: `${MANAGE_NOTES_V2.UPDATE}/${id}`,
                data
            }),
            invalidatesTags: ["NoteDetails", "NoteView"]
            // async onQueryStarted(arg, { dispatch, queryFulfilled }) {
            //     try {
            //         await queryFulfilled;

            //         // Invalidate tag from another API
            //         dispatch(
            //             noteApi.util.invalidateTags(["NoteDetails"])
            //         );
            //     } catch (err) {
            //         console.error("Failed to update note:", err);
            //     }
            // },
        }),

        getNotesList: builder.query({
            query: ({ page = 1, limit = 10, search = "", date = "", owner = null, sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${MANAGE_NOTES_V2.LIST}`,
                data: { page, limit, sort, search, date, owner: owner?.value }
            }),
            providesTags: ["NoteDetails"],
            transformResponse: (response) => {
                return response.data;
            },
        }),

        noteView: builder.query({
            query: ({ noteId }) => ({
                method: "GET",
                url: `${MANAGE_NOTES_V2.VIEW}/${noteId}`,
            }),
            providesTags: ["NoteView"],
            transformResponse: (response) => {
                return response.data;
            },
        }),

        // delete note
        deleteNote: builder.mutation({
            query: ({ id }) => ({
                method: "DELETE",
                url: `${MANAGE_NOTES_V2.DELETE}/${id}`
            }),
            invalidatesTags: ["NoteDetails"]
        }),

        noteAcceptSuggestion: builder.query({
            query: ({ descision, suggestionId, noteId }) => ({
                method: "GET",
                url: `${MANAGE_NOTES_V2.ACCEPT_SUGGESTION}/${descision}/${suggestionId}/${noteId}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            invalidatesTags: ["NoteDetails", "NoteView"]
        }),

        createComment: builder.mutation({
            query: ({ noteId, data }) => ({
                method: "PUT",
                url: `${MANAGE_NOTES_V2.COMMENTS.CREATE}/${noteId}`,
                data
            }),
            invalidatesTags: ["NoteView", "NoteComments"]
        }),

        updateComment: builder.mutation({
            query: ({ id, noteId, data }) => ({
                method: "PUT",
                url: `${MANAGE_NOTES_V2.COMMENTS.UPDATE}/${id}/${noteId}`,
                data
            }),
            invalidatesTags: ["NoteView", "NoteComments"]
        }),

        deleteComment: builder.mutation({
            query: ({ id, noteId }) => ({
                method: "DELETE",
                url: `${MANAGE_NOTES_V2.COMMENTS.DELETE}/${id}/${noteId}`
            }),
            invalidatesTags: ["NoteView", "NoteComments"]
        }),

        getNoteCommentsList: builder.query({
            query: ({ noteId, search = "", date = "", owner = null, sort = { column: "id", direction: "DESC" } }) => ({
                method: "POST",
                url: `${MANAGE_NOTES_V2.COMMENTS.LIST}/${noteId}`,
                data: { sort, search, date, filterBy: owner?.value }
            }),
            providesTags: ["NoteComments"],
            transformResponse: (response) => {
                return response?.data?.record;
            },
        }),

        getNoteOwnersFilterList: builder.query({
            query: () => ({
                method: "GET",
                url: `${MANAGE_NOTES_V2.OWNERS_FILTER}`,
            }),
            providesTags: ["NoteOwnerFilter"],
            transformResponse: (response) => {
                return response?.data;
            },
        }),

    }),
})

export const {
    useCreateNoteMutation,
    useUpdateNoteMutation,
    useGetNotesListQuery,
    useNoteViewQuery,
    useDeleteNoteMutation,
    useLazyNoteAcceptSuggestionQuery,
    useCreateCommentMutation,
    useUpdateCommentMutation,
    useDeleteCommentMutation,
    useGetNoteCommentsListQuery,
    useGetNoteOwnersFilterListQuery
} = noteApiV2;